export default __webpack_public_path__ + "static/media/stone_three_logo_transparent_white.130ee003.png";